import { SanityImageFragment } from '@data/sanity/queries/types/image'
import { getSanityImageUrl } from '@lib/image'
import { Locale } from '@lib/language'
import { uploadAssetToShopify } from '@lib/shopify/file'

/**
 * Uploads print image to Shopify and gets its file ID.
 */
export const uploadPrintImageToShopify = async (
  locale: Locale,
  image?: SanityImageFragment,
) => {
  const imageUrl = getSanityImageUrl(image)

  if (!image || !imageUrl) {
    return
  }

  const fileId = await uploadAssetToShopify(locale, {
    url: imageUrl,
    mimeType: image.type,
    filename: image.filename,
  })

  return fileId
}
